<template>
    <b-modal id="modal-forget" centered class="modal-forget">
      <div class="modal-forget-itens">
        <button
          class="modal-forget-itens-close"
          @click="closeModals()"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="33.598" height="17.831" viewBox="0 0 33.598 17.831">
            <g id="Group_2368" data-name="Group 2368" transform="translate(-42.507 -69.243)">
                <path id="Union_1" data-name="Union 1" d="M10.925,0h.683V11.608h-.683V.683H0V0Z" transform="translate(67.19 86.367) rotate(-135)" fill="#173f35" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Union_1-2" data-name="Union 1" d="M10.925,0h.683V11.608h-.683V.683H0V0Z" transform="translate(51.422 69.95) rotate(45)" fill="#173f35" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            </g>
        </svg>
        </button>
      </div>
      <div class="modal-forget-content">
        <h3>Quero ser esquecido</h3>
        <p>Preencha o seu email para receber as instruções de envio</p>
        <form @submit.prevent="sendForm()">
            <div class="row">
                <div class="col-md-12">
                    <input type="text" name="email" v-model="email" :placeholder="user?.email">
                </div>
            </div>
            <div class="content-input-button">
                <div class="btn btn-send">
                    <button type="submit">gravar</button>
                </div>
            </div>
        </form>
      </div>
    </b-modal>
  </template>
  
  <script> 
  import axios from 'axios';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    data() {
      return {
        email: null
      }
    },
    computed: {
      ...mapGetters(['user'])
    },
    methods: {
      ...mapActions(["accountLogout"]),
        closeModals(){
            this.$bvModal.hide('modal-forget')
            this.$bvModal.hide('modal-rgpd')
        },
        logout(){
          this.accountLogout()
          .then(() => {
              this.$router.push('/home');
          }).catch((error) => {
              console.log(error);
          });
      },
        async sendForm(){
          const userEmail = this.email || (this.user ? this.user.email : null);
            await axios.post('api/v1/user/forget', {
                id: localStorage.getItem('token') || null,
                email: userEmail
            }).then((response) => {
                if(response.data.success === true){
                    this.logout();
                    this.$bvModal.hide('modal-forget')
                    this.$bvModal.hide('modal-rgpd')
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Sucesso',
                        text: 'Pedido de esquecimento enviado com sucesso!',
                    })
                } else {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Ocorreu um erro ao enviar o pedido de esquecimento. Tente novamente!',
                    })
                }
            }).catch((error) => {
                console.log(error);
                this.$swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Ocorreu um erro ao enviar o pedido de portabilidade!',
                })
            })
        }
    },
    mounted() {
      this.email = this.user?.email;
    }
  };
  </script>
  
  <style lang="scss">
  #modal-forget {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 463px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: 463px;
      }
    }
  }
  .modal-forget {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -20px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        max-height: 290px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        form{
            width: 100%;
            display: flex;
            flex-direction: column;
            .row{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
                input{
                    width: 100%;
                    height: 50px;
                    border: none;
                    background-color: var(--white);
                    border: 1px solid #B8B8B8;
                    text-align: center;
                    border-radius: 5px;
                    margin-bottom: 20px;
                    font-size: 18px;
                    font-family: "Font Regular";
                    color: #B8B8B8;
                    &::placeholder{
                        font-size: 18px;
                        font-family: "Font Regular";
                        color: var(--black);
                    }
                }
            }
        }
    }
  }
.content-input-button{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        width: 280px;
        height: 56px;
        border: none;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        text-align: center;
        border-radius: 10px;
        padding: 0 20px;
        font-size: 18px;
        font-family: "Font Regular";
        color: black;
        transition: 500ms;
        text-transform: uppercase;
    }
}
  </style>